import { render } from "./AppForbidden.vue?vue&type=template&id=44d7ac6f&ts=true"
import script from "./AppForbidden.vue?vue&type=script&lang=ts"
export * from "./AppForbidden.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__